import { IAlert } from '../../../shared/components/CustomAlert'
import { GridSetup, IRole } from '../models/role-model'

export const ROLE_FORM_DEFAULT: IRole = {
  id: '',
  name: '',
  displayId: 0,
  isActive: true
}

export const Initial_GridSetup: GridSetup = {
  sort: [{ field: 'id', dir: 'desc' }],
  skip: 0,
  take: 10,
  filter: {
    logic: 'and',
    filters: []
  }
}

export const TOASTER_DEFAULT: IAlert = {
  message: ``,
  header: ``,
  type: 'success'
}

export enum PAGE_ACTION {
  View = 'View',
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete'
}

export enum PAGE_PERMISSION {
  PortfolioOverview = 'PortfolioOverview',
  Dashboard = 'Dashboard',
  Project_SetupWizard = 'ProjectSetup',
  Project_Details = 'ProjectDetails',
  Reports_VariationAssessments = 'Variations',
  Reports_ProgressClaim = 'ProgressClaims',
  Reports_PcgReport = 'PCG',
 
  Cashflow = 'Cashflow',
  Budget = 'Budget',
  Milestones = 'Milestones',
  Document_Registry = ' DocumentRegistry',
  Contacts = 'Contacts',
  
  
  Users = 'Users',
  Roles = 'Roles',
  Settings = 'Settings',
  Charts = 'Charts',
  Admin_Audit = `Audit`,
  Admin_Audit_Logs = `AuditLogs`,

  Notification = 'Notification'
}
